import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";
import Navigation from "../components/Navigation";
import PageHero from "../components/PageHero";

// Sponsors Page
const SponsorsPage = () => {
  const foodSponsors = [
    { 
      name: "Philabundance", 
      url: "https://www.philabundance.org/",
      logo: "https://customer-assets.emergentagent.com/job_25fea3a8-d44f-4611-af87-de4e9c9c0796/artifacts/njvx7u7a_Philabundance.png"
    },
    { 
      name: "Share Food Program", 
      url: "https://www.sharefoodprogram.org/",
      logo: "https://customer-assets.emergentagent.com/job_25fea3a8-d44f-4611-af87-de4e9c9c0796/artifacts/xjzgm6fa_Share%20Food.png"
    },
    { 
      name: "Trader Joe's", 
      url: "https://locations.traderjoes.com/pa/ardmore/635/",
      logo: "https://customer-assets.emergentagent.com/job_7b46b431-509a-4162-84d5-ce52c765da4c/artifacts/i7szzedk_Trader%20Joes.png"
    },
  ];

  const platinumSponsors = [
    { 
      name: "United Way of Greater Philadelphia and Southern New Jersey", 
      url: "https://unitedforimpact.org/",
      logo: "https://customer-assets.emergentagent.com/job_25fea3a8-d44f-4611-af87-de4e9c9c0796/artifacts/kjigslyc_United%20Way.png"
    },
    { 
      name: "Saunders House Foundation", 
      url: "https://www.saundershousefoundation.org/",
      logo: "https://customer-assets.emergentagent.com/job_4bb091c1-e4be-474e-9067-19b51e555ba6/artifacts/j5dc945w_Saunders%20House.jpg",
      logoSize: "h-[72px]"
    },
    { 
      name: "Griswold Industries/Cla-Val", 
      url: "https://www.cla-val.com/",
      logo: "https://customer-assets.emergentagent.com/job_25fea3a8-d44f-4611-af87-de4e9c9c0796/artifacts/kdkcw39b_Cla-val.png"
    },
    { 
      name: "Delaware County Interactive Gaming Revenue Authority", 
      url: "https://dcigra.org/",
      logo: "https://customer-assets.emergentagent.com/job_25fea3a8-d44f-4611-af87-de4e9c9c0796/artifacts/zedjtcs6_DCIGRA.jpg"
    },
    { 
      name: "The Foundation for Delaware County", 
      url: "https://delcofoundation.org/",
      logo: "https://customer-assets.emergentagent.com/job_25fea3a8-d44f-4611-af87-de4e9c9c0796/artifacts/k5gbj7ke_Foundation%20for%20Delaware%20County%20logo.jpg"
    },
  ];

  const goldSponsors = [
    { 
      name: "Genuardi Family Foundation", 
      url: "https://genuardifamilyfoundation.org/",
      logo: "https://customer-assets.emergentagent.com/job_25fea3a8-d44f-4611-af87-de4e9c9c0796/artifacts/z5vampz3_Genuardi.png"
    },
    { 
      name: "The Leo and Peggy Pierce Family Foundation", 
      url: "https://piercefamilyfdn.org/",
      logo: "https://customer-assets.emergentagent.com/job_25fea3a8-d44f-4611-af87-de4e9c9c0796/artifacts/xfq1mjbb_Pierce.png"
    },
    { 
      name: "Upper Darby Township", 
      url: "https://www.upperdarby.org/",
      logo: "https://customer-assets.emergentagent.com/job_25fea3a8-d44f-4611-af87-de4e9c9c0796/artifacts/wosyxmea_Upper%20Darby%20Township.png"
    },
    { 
      name: "Connelly Foundation", 
      url: "https://www.connellyfdn.org/",
      logo: "https://customer-assets.emergentagent.com/job_25fea3a8-d44f-4611-af87-de4e9c9c0796/artifacts/nmm0242q_Connelly.jpg"
    },
    { 
      name: "Martin W. Pickett", 
      url: null,
      logo: "https://customer-assets.emergentagent.com/job_25fea3a8-d44f-4611-af87-de4e9c9c0796/artifacts/2nwm8myc_Thank%20you.jpg"
    },
    { 
      name: "Gail Ruehr", 
      url: null,
      logo: "https://customer-assets.emergentagent.com/job_25fea3a8-d44f-4611-af87-de4e9c9c0796/artifacts/2nwm8myc_Thank%20you.jpg"
    },
  ];

  const silverSponsors = [
    "Enterprise Taylor Charitable Entities",
    "Independence Foundation",
    "Anna W Raphaelidis Memorial Fund",
    "Chekemma Townsend, Hamilton Family Charitable Trust",
    "Irene D Cunningham Trust",
    "Kathryn Ingber",
    "Philadelphia Foundation",
    "Scott Ruehr",
  ];

  const bronzeSponsors = [
    "Highmark Wholecare",
    "Kim and Mike Flanagan",
    "Conaghan Graham Family Trust",
    "Cynthia A Hubbard",
    "Ethel Sergeant Clark Smith Memorial Fund",
    "Steven Blum",
    "Whole Foods",
    "Benjamin Johns",
    "Kathleen Scully",
    "Belmont Family Fund for Delco",
    "The Essential Foundation",
    "UNICO National",
    "WSFS Cares Foundation",
    "Kernan and Ipsen Giving Fund",
    "Fighting Food Insecurity in Delco",
    "Pincus Fund for Hunger Relief",
    "The Community Foundation",
    "Coutts Family Foundation",
    "TruMark Financial Cares Foundation",
    "Wawa",
    "Bruce Flamm",
    "The Briant family",
    "Alca Gideon",
    "Christian Arakelian",
    "David Pogue",
    "DCMS Public Health Fund",
    "Franklin Mint Federal Credit Union Foundation",
    "Jack Piccininni",
    "Jennifer Alleva",
    "Jim O'Brien",
    "Lisa Partridge",
    "Rani Hoff",
    "Raymond Baraldi",
    "Sierra Murphy",
    "The Mattise Family Charitable Fund",
    "Thomas E Harms",
    "Yoo Seop Han",
  ];

  return (
    <div data-testid="sponsors-page" className="min-h-screen bg-[#FAFAFA]">
      <Navigation />
      
      <PageHero 
        image="https://customer-assets.emergentagent.com/job_7b46b431-509a-4162-84d5-ce52c765da4c/artifacts/2vwbnevx_Yasmine.jpg"
        alt="Sponsors"
        objectPosition="center 25%"
      />

      {/* Content */}
      <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 
              data-testid="sponsors-title"
              className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A1A] mb-12"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Sponsors
            </h1>

            {/* We receive food from... */}
            <div className="mb-12">
              <h2 
                className="text-2xl md:text-3xl font-bold text-[#1A1A1A] mb-6"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                We receive food from...
              </h2>
              <div className="space-y-3">
                {foodSponsors.map((sponsor, index) => (
                  <motion.div
                    key={sponsor.name}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    className="bg-white rounded-xl shadow-sm border border-gray-100 p-5"
                  >
                    <a 
                      href={sponsor.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-block hover:opacity-80 transition-opacity"
                    >
                      <img 
                        src={sponsor.logo} 
                        alt={sponsor.name}
                        className="h-20 w-auto max-w-[280px] object-contain"
                      />
                    </a>
                  </motion.div>
                ))}
              </div>
            </div>

            {/* We are supported by... */}
            <div>
              <h2 
                className="text-2xl md:text-3xl font-bold text-[#1A1A1A] mb-8"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                We are supported by...
              </h2>

              {/* Platinum Leadership Circle - Largest */}
              <div className="mb-10">
                <h3 
                  className="text-2xl md:text-3xl font-bold text-[#7B9EBE] mb-5"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  Platinum Leadership Circle
                </h3>
                <div className="space-y-3">
                  {platinumSponsors.map((sponsor, index) => (
                    <motion.div
                      key={sponsor.name}
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.5, delay: index * 0.05 }}
                      className="bg-white rounded-xl shadow-sm border border-gray-100 p-5"
                    >
                      {sponsor.url ? (
                        <a 
                          href={sponsor.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center gap-4 group"
                        >
                          <div className="w-[160px] flex-shrink-0 flex items-center">
                            <img 
                              src={sponsor.logo} 
                              alt={`${sponsor.name} logo`}
                              className={`${sponsor.logoSize || 'h-16'} w-auto max-w-[140px] object-contain`}
                            />
                          </div>
                          <span className="text-[#7B9EBE] group-hover:text-[#5a7d9e] font-semibold text-xl transition-colors inline-flex items-center gap-2">
                            {sponsor.name}
                            <ChevronRight size={20} />
                          </span>
                        </a>
                      ) : (
                        <div className="flex items-center gap-4">
                          <div className="w-[160px] flex-shrink-0 flex items-center">
                            <img 
                              src={sponsor.logo} 
                              alt={`${sponsor.name} logo`}
                              className={`${sponsor.logoSize || 'h-16'} w-auto max-w-[140px] object-contain`}
                            />
                          </div>
                          <span className="text-[#7B9EBE] font-semibold text-xl">
                            {sponsor.name}
                          </span>
                        </div>
                      )}
                    </motion.div>
                  ))}
                </div>
              </div>

              {/* Gold Benefactors - Regular */}
              <div className="mb-8">
                <h3 
                  className="text-xl md:text-2xl font-bold text-[#B8860B] mb-4"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  Gold Benefactors
                </h3>
                <div className="grid md:grid-cols-2 gap-2">
                  {goldSponsors.map((sponsor, index) => (
                    <motion.div
                      key={sponsor.name}
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.5, delay: index * 0.05 }}
                      className="bg-white rounded-lg shadow-sm border border-gray-100 p-4"
                    >
                      {sponsor.url ? (
                        <a 
                          href={sponsor.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center gap-3 group"
                        >
                          <div className="w-[60px] flex-shrink-0 flex items-center">
                            <img 
                              src={sponsor.logo} 
                              alt={`${sponsor.name} logo`}
                              className="h-10 w-auto max-w-[60px] object-contain"
                            />
                          </div>
                          <span className="text-[#B8860B] group-hover:text-[#8B6914] font-semibold text-base transition-colors">
                            {sponsor.name}
                          </span>
                        </a>
                      ) : (
                        <div className="flex items-center gap-3">
                          <div className="w-[60px] flex-shrink-0 flex items-center">
                            <img 
                              src={sponsor.logo} 
                              alt="Thank you"
                              className="h-10 w-auto max-w-[60px] object-contain"
                            />
                          </div>
                          <span className="text-[#B8860B] font-semibold text-base">
                            {sponsor.name}
                          </span>
                        </div>
                      )}
                    </motion.div>
                  ))}
                </div>
              </div>

              {/* Silver Partners - Smaller */}
              <div className="mb-6">
                <h3 
                  className="text-lg md:text-xl font-bold text-[#808080] mb-3"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  Silver Partners
                </h3>
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-1.5">
                  {silverSponsors.map((sponsor, index) => (
                    <motion.div
                      key={sponsor}
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.5, delay: index * 0.03 }}
                      className="bg-white rounded-md shadow-sm border border-gray-100 px-3 py-2"
                    >
                      <span className="text-[#1A1A1A] font-medium text-sm">
                        {sponsor}
                      </span>
                    </motion.div>
                  ))}
                </div>
              </div>

              {/* Bronze Supporters - Smallest */}
              <div>
                <h3 
                  className="text-base md:text-lg font-bold text-[#CD7F32] mb-2"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  Bronze Supporters
                </h3>
                <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-1">
                  {bronzeSponsors.map((sponsor, index) => (
                    <motion.div
                      key={sponsor}
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.5, delay: index * 0.02 }}
                      className="bg-white rounded shadow-sm border border-gray-100 px-2 py-1.5"
                    >
                      <span className="text-[#1A1A1A] text-xs">
                        {sponsor}
                      </span>
                    </motion.div>
                  ))}
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default SponsorsPage;
